function initializeCollectionTools(root = document) {
  for (const trigger of root.querySelectorAll('[data-mg-filter-open]:not([data-initialized])')) {
    const dialog = document.getElementById(trigger.getAttribute('aria-controls'));
    if (!(dialog instanceof HTMLDialogElement)) continue;
    trigger.dataset.initialized = 'true';
    trigger.addEventListener('click', () => dialog.showModal());
    dialog.querySelector('[data-mg-filter-close]')?.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
    });
    dialog.addEventListener('close', () => trigger.focus());
  }
}
initializeCollectionTools();
document.addEventListener('shopify:section:load', event => initializeCollectionTools(event.target));
